// src/cmps/UserProfile/UserWatchlist/EmptyWatchlist.jsx
import { PlusIcon } from '../../ui/icons/shared'
import { EmptyWatchlistIcon } from '../../ui/icons/user'

export function EmptyWatchlist({ onAdd, statusValue }) {
  return (
    <div className="flex flex-col items-center gap-4 text-white mt-10">
      <EmptyWatchlistIcon />
      <h3 className="text-xl text-center w-[300px]">
        התחל לנהל את רשימת הצפייה שלך והוסף את האנימה הראשונה לאניזון!
      </h3>
      <button
        className="flex gap-2 items-center text-softText "
        onClick={() => {
          onAdd(statusValue)
          window.scrollTo({ top: 600, behavior: 'smooth' })
        }}
      >
        <div className="w-6 h-6 bg-accent rounded-full flex items-center justify-center">
          <PlusIcon />
        </div>
        הוספה
      </button>
    </div>
  )
}
